import { postApiSegment } from "../../../dataLayer/dataPost";
import { getClipTitle } from "../clip/utils";
import { analytics } from "MVVM/Analytics";
export const openWebShare = ({ file, clip }) => {
  navigator
    .share({
      files: [file],
      title: getClipTitle(clip),
    })
    .then(() => console.log("Share was successful."))
    .catch((error) => console.log("Sharing failed", error));
};

export const trackClipSocialShare = ({
  platform,
  handler,
  clip,
  queue,
  data,
  aspectRatio,
  isMontage,
}) => {
  // handler({
  //   url: `https://jsonplaceholder.typicode.com/todos/1`,
  //   method: "GET",
  // });
  // return;

  analytics.track("Clip Shared", {
    clipID: clip._id,
    game: clip.game,
    tags: clip.clipProperties,
    length: clip.clipLength,
    clipOwner: clip.user?._id,
    shareDestination: platform,
    shareId: clip?.shareId,
    isMontage: isMontage,
  });

  const analyticsProperties = {
    clipName: getClipTitle(clip),
    game: clip.game,
    tags: clip.clipProperties,
    length: clip.clipLength,
    total_reactions: clip.totalReactions,
    total_views: clip.views,
    shareDestination: platform,
    shareId: clip?.shareId,
    isMontage: isMontage,
  };

  const uploadPlatforms = ["YouTube", "TikTok"];

  if (handler && uploadPlatforms.includes(platform)) {
    handler({
      method: "POST",
      url: `${process.env.REACT_APP_API_URL}/items/clip/upload${
        queue === true ? "?queue=true" : ""
      }`,
      data: {
        _id: clip._id,
        platform,
        data,
        aspectRatio,
        analytics: analyticsProperties,
      },
    });
  } else {
    postApiSegment({
      event: "Creator - Clip Shared",
      userId: clip.user?._id,
      properties: analyticsProperties,
    });
  }
};

export const trackCreatorCardShare = (card) => {
  analytics.track("Creator Card Shared", {
    cardId: card._id,
    badge: card.ui.badge,
    category: card.ui.category,
    cost: card.ui.cost,
    rarity: card.ui.rarity,
    uses: card.ui.uses,
    useType: card.ui.useType,
  });
};
